export const BILLING_ADDRESS_FIELDS = ['address_line1', 'address_line2', 'city', 'state', 'zip'];

export const PAGE_NAMES = {
  ADD_CARD: 'addCardPage',
  ADD_ADDRESS: 'addAddressPage',
  SELECT_CARD: 'selectCardPage',
};

export const PAGE_CHANGE_SIGNALS = {
  CARD_FORM_SUBMITTED: 'cardFormSubmitted',
  ADDRESS_FORM_SUBMITTED: 'addressFormSubmitted',
  SHOW_ADD_CARD_SCREEN: 'showAddCardScreen',
  CANCEL_ADD_CARD: 'cancelAddCard',
  CARD_SUBMISSION_ERROR: 'cardSubmissionError',
};

export const ERROR_MESSAGES = {
  DEFAULT_PAYMENT_METHOD: 'You cannot remove your default payment method.',
  LAST_PAYMENT_METHOD: 'You cannot remove your last payment method.',
};

export type CardIds = 'amex' | 'visa' | 'mastercard' | 'discover';
export type CardDisplayNames = 'AmEx' | 'Visa' | 'MasterCard' | 'Discover';

const amex = {
  id: 'amex',
  display: 'AmEx',
  long: 'American Express',
};

const visa = {
  id: 'visa',
  display: 'Visa',
  long: 'Visa',
};

const mastercard = {
  id: 'mastercard',
  display: 'MasterCard',
  long: 'MasterCard',
};

const discover = {
  id: 'discover',
  display: 'Discover',
  long: 'Discover',
};

export const CARD_TYPES = {
  visa,
  mastercard,
  'master-card': mastercard,
  discover,
  amex,
  'american express': amex,
  'american-express': amex,
};

const constants = {
  BILLING_ADDRESS_FIELDS,
  PAGE_NAMES,
  PAGE_CHANGE_SIGNALS,
  ERROR_MESSAGES,
  CARD_TYPES,
};

export default constants;



// WEBPACK FOOTER //
// ../react-lib/src/constants/creditCard.constants.ts